import { memo } from 'react';
import { EditableCell } from './EditableCell';
import { ProjectDateCellContent } from './ProjectDateCellContent';
import type { Project } from '@/api/client';
import { getBaseStatus } from '@/utils/projectStatuses';
import { highlightPlainText } from '@/utils/highlightSearchTerms';

interface PaperBookPlanCellProps {
  project: Project;
  searchHighlightWords?: string[];
}

const EmptyValue = () => <span className="projects-table__empty-value">N/A</span>;

export const PaperBookPlanCell = memo(function PaperBookPlanCell({
  project,
  searchHighlightWords,
}: PaperBookPlanCellProps) {
  const { paper_book_plan, is_backlog, state } = project;
  const isCompleted = getBaseStatus(state) === 'Готов';

  const display = is_backlog ? (
    <span className="projects-table__paper-plan-value projects-table__paper-plan_backlog">
      {searchHighlightWords?.length ? highlightPlainText('Бэклог', searchHighlightWords) : 'Бэклог'}
    </span>
  ) : paper_book_plan?.trim() ? (
    <ProjectDateCellContent
      dateStr={paper_book_plan}
      isCompleted={isCompleted}
      todayLabel="Выход сегодня"
      containerClassName="projects-table__paper-plan-cell"
      searchHighlightWords={searchHighlightWords}
    />
  ) : (
    <EmptyValue />
  );

  return (
    <EditableCell project={project} fieldKey="paper_book_plan">
      {display}
    </EditableCell>
  );
});
